module.exports = __webpack_public_path__ + "static/media/dong_song_text_01.1a43f4b1.jpg";